<template>
    <span v-if="mostrarBtn">
        <b-button variant="primary" @click.stop="abrir()">
            <span>Processar Solicitação</span>
        </b-button>
        <b-modal v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Processar Solicitação de Autorização para Envio Fora do Prazo
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <strong>
                            <label>Resultado</label>
                        </strong>
                        <b-form-select
                            :plain="true"
                            :options="resultadoOptions"
                            v-model="resultado"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.prazoLimite.$error ? false : null"
                        invalid-feedback="Prazo limite é obrigatório"
                    >
                        <label>Prazo Limite</label>
                        <date-picker
                            ref="dp01"
                            v-model="prazoLimite"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.prazoLimite.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarProcessar()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-check"></i> Processar Solicitação
                    </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            justificativa: '',
            resultado: 0,
            resultadoOptions: [
                { text: 'APROVADA', value: 1 },
                { text: 'REPROVADA', value: 2 }
            ],
            prazoLimite: null,
            dataMinima: this.$moment(new Date()).format('YYYY-MM-DD'),
            dataMaxima: this.$moment(new Date())
                .endOf('month')
                .format('YYYY-MM-DD')
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.justificativa = ''
            this.resultado = 0
        },

        preencherForm() {
            this.prazoLimite = this.$moment(new Date())
                .endOf('month')
                .format('DD/MM/YYYY')
        },

        confirmarProcessar() {
            let acao = this.resultado == 1 ? 'APROVAÇÃO' : 'REPROVAÇÃO'
            this.$swal({
                title: `Solicitação de Autorização para Envio Fora do Prazo`,
                html: `Confirma a ${acao} da solicitação de autorização para envio fora do prazo do registro de pagamento ${this.pagamento.protocolo}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.processarSolicitacao()
                }
            })
        },

        processarSolicitacao() {
            this.$store.dispatch('addRequest')
            let solicitacaoDto = {
                pagamentoId: this.$route.params.pagamentoId,
                resultado: this.resultado,
                justificativa: this.justificativa,
                prazoLimite: this.$moment(
                    this.prazoLimite,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }
            this.pagamentosServicos
                .processarSolicitacao(solicitacaoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação processada com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.fechar()
                        } else {
                            this.$toast.error(
                                'Erro ao processar solicitação!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.pagamento.status === pagamentoStatus.CRIADO &&
                this.pagamento.qtdComprometimentos > 0 &&
                this.pagamento.qtdAnexos > 0 &&
                !this.pagamento.envioPermitido &&
                this.pagamento.solicitacaoParaEnvioEmAnalise &&
                this.$temAcesso('CONT-PAG-06')
            )
        },

        dataPrazoLimite() {
            return this.$moment(this.prazoLimite, 'DD/MM/YYYY')
        }
    },

    validations: {
        justificativa: {
            required
        },
        resultado: {
            required
        },
        prazoLimite: {
            required,
            dataOk() {
                return (
                    this.dataPrazoLimite.isSameOrAfter(this.dataMinima) &&
                    this.dataPrazoLimite.isSameOrBefore(this.dataMaxima)
                )
            }
        }
    }
}
</script>
